export const GET_CHITIET_HOPDONG = "GET_CHITIET_HOPDONG";
export const GET_CHITIET_HOPDONG_SUCCESS = "GET_CHITIET_HOPDONG_SUCCESS";
export const GET_CHITIET_HOPDONG_FAILURE = "GET_CHITIET_HOPDONG_FAILURE";

export const GET_LICH_SU_HOP_DONG = "GET_LICH_SU_HOP_DONG";
export const GET_LICH_SU_HOP_DONG_SUCCESS = "GET_LICH_SU_HOP_DONG_SUCCESS";
export const GET_LICH_SU_HOP_DONG_FAILURE = "GET_LICH_SU_HOP_DONG_FAILURE";

export const GET_LICH_SU_VT_TB = "GET_LICH_SU_VT_TB";
export const GET_LICH_SU_VT_TB_SUCCESS = "GET_LICH_SU_VT_TB_SUCCESS";
export const GET_LICH_SU_VT_TB_FAILURE = "GET_LICH_SU_VT_TB_FAILURE";

export const GET_LIST_TAI_SAN_CAM_CO = "GET_LIST_TAI_SAN_CAM_CO";
export const GET_LIST_TAI_SAN_CAM_CO_SUCCESS =
  "GET_LIST_TAI_SAN_CAM_CO_SUCCESS";
export const GET_LIST_TAI_SAN_CAM_CO_FAILURE =
  "GET_LIST_TAI_SAN_CAM_CO_FAILURE";

export const GET_LICH_SU_NO_PHAI_THU = "GET_LICH_SU_NO_PHAI_THU";
export const GET_LICH_SU_NO_PHAI_THU_SUCCESS =
  "GET_LICH_SU_NO_PHAI_THU_SUCCESS";
export const GET_LICH_SU_NO_PHAI_THU_FAILURE =
  "GET_LICH_SU_NO_PHAI_THU_FAILURE";

export const GET_LIST_GHI_CHU = "GET_LIST_GHI_CHU";
export const GET_LIST_GHI_CHU_SUCCESS = "GET_LIST_GHI_CHU_SUCCESS";
export const GET_LIST_GHI_CHU_FAILURE = "GET_LIST_GHI_CHU_FAILURE";
